import { createContext, useContext } from "react"

interface AdminContextValue {
  isAdmin: boolean
}

const AdminContext = createContext<AdminContextValue | undefined>(undefined)

export const AdminProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isAdmin = window.location.pathname.startsWith("/super-skryty-admin")
  return (
    <AdminContext.Provider value={{ isAdmin }}>
      {children}
    </AdminContext.Provider>
  )
}

export const useAdminContext = () => {
  const ctx = useContext(AdminContext)
  if (!ctx) {
    throw new Error("useAdminContext must be used inside <AdminProvider>")
  }
  return ctx
}
